import { Outlet } from "react-router-dom";
import { useAppContext } from "../../contexts/app/index";

export default function EmbedApp() {
  const { state } = useAppContext();

  if (!state.isLoaded) {
    return null;
  }

  return <Outlet />;
}
